<template>
  <div class="FontSize14 flex_start">
    <div>您的位置 ：</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in tolist"
        :key="index"
        @click.native="tojump(item)"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    tolist: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    tojump(item) {
      this.$router.push({path:item.path})
    },
  },
};
</script>

<style lang="scss" >
 .el-breadcrumb__inner{
   cursor: pointer;
 }
</style>